import script from "./PdfViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./PdfViewer.vue?vue&type=script&setup=true&lang=js"

import "./PdfViewer.vue?vue&type=style&index=0&id=4ced6eed&scoped=true&lang=css"

import exportComponent from "/Users/dioratar/Documents/_project/omni/repo/emetrai/event-panel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ced6eed"]])

export default __exports__